import { Component, Input } from '@angular/core';

import { faArrowLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { HeaderNavLink } from '../header/header';
import { QueryParamDirective } from '@core-mkt/services/query-param/query-param.directive';

@Component({
  selector: 'collapse-link',
  templateUrl: './collapse-link.component.html',
  styleUrls: ['./collapse-link.component.scss'],
  standalone: true,
  imports: [FaIconComponent, QueryParamDirective],
})
export class CollapseLinkComponent {
  @Input() link: HeaderNavLink;
  collapsed = true;
  faCaretRight = faChevronRight;
  faArrowLeft = faArrowLeft;

  constructor() {}
}
